import Vue from 'vue'
import store from '@/store'

// if (!Function.prototype.bind) {
//     Function.prototype.bind = function () {
//         let fn = this; let args = Array.prototype.slice.call(arguments); let
//             object = args.shift()
//         return function () {
//             return fn.apply(object, args.concat(Array.prototype.slice.call(arguments)))
//         }
//     }
// }

const Utils = Object.create(null)

Utils.encode = function (_map, _content) {
    _content = '' + _content
    if (!_map || !_content) {
        return _content || ''
    }
    return _content.replace(_map.r, $1 => {
        let _result = _map[!_map.i ? $1.toLowerCase() : $1]
        return _result != null ? _result : $1
    })
}

Utils.escape = (function () {
    let _reg = /<br\/?>$/
    let _map = {
        r: /\<|\>|\&|\r|\n|\s|\'|\"/g,
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        ' ': '&nbsp;',
        '"': '&quot;',
        '\'': '&#39;',
        '\n': '<br/>',
        '\r': '',
    }
    return function (_content) {
        _content = Utils.encode(_map, _content)
        return _content.replace(_reg, '<br/>')
    }
}())

// https://cn.vuejs.org/v2/guide/reactivity.html
// Vue 不能检测到对象属性的添加或删除。然而它可以使用 Vue.set(object, key, value) 方法将响应属性添加到嵌套的对象上
Utils.mergeObject = function (dest, src) {
    if (typeof dest !== 'object' || dest === null) {
        dest = Object.create(null)
    }
    dest = Object.assign(Object.create(null), dest, src)
    return dest
}

Utils.mergeVueObject = function (dest, src) {
    let keys = Object.keys(src)
    keys.forEach(item => {
        if (typeof src[item] !== 'undefined') {
            Vue.set(dest, item, src[item])
        }
    })
    return dest
}

// 消息类型列表
Utils.mapMsgType = function (type) {
    let map = {
        image: 'Picture message',
        audio: 'Voice message',
        custom: 'Other message',
        file: 'PDF message',
    }
    return map[type]
}
// 消息类型列表
Utils.mapOrderType = function (type) {
    let map = {
        CREATED: 'label_created',
        CONFIRMED: 'label_confirmed',
        PICKED: 'label_picked',
        PACKED: 'label_packed',
        SHIPPED: 'label_shipped',
        INVOICED: 'label_invoiced',
        SETTLED: 'label_settled',
        CANCELLED: 'label_cancelled',
    }
    return map[type]
}

Utils.stringifyDate = function (datetime, lang, simple = false) {
    let weekMap
    let today
    let yesterday
    let monthMap
    if (lang === 'en-TH') {
        weekMap = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        monthMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        today = 'Today'
        yesterday = 'Yesterday'
    } else {
        weekMap = ['วันอาทิตย์', 'วันจันทร์', 'วันอังคาร', 'วันพุธ', 'วันพฤหัสบดี', 'วันศุกร์', 'วันเสาร์']
        monthMap = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
        today = 'วันนี้'
        yesterday = 'เมื่อวาน'
    }
    datetime = new Date(datetime)
    let year = datetime.getFullYear()
    let simpleYear = datetime.getYear() - 100
    let month = datetime.getMonth() + 1
    let monthFormat = monthMap[month - 1]
    month = month > 9 ? month : '0' + month
    let day = datetime.getDate()
    day = day > 9 ? day : '0' + day
    let hour = datetime.getHours()
    hour = hour > 9 ? hour : '0' + hour
    let min = datetime.getMinutes()
    min = min > 9 ? min : '0' + min
    let week = datetime.getDay()
    week = weekMap[week]
    let thatDay = (new Date(year, month - 1, day, 0, 0, 0)).getTime()
    if (simple) {
        return {
            withYear: `${day}/${month}/${simpleYear}`,
            withMonth: `${month}-${day}`,
            withDay: `${week}`,
            withLastDay: `${yesterday}`,
            withHour: `${hour}:${min}`,
            withNoWeekAll: `${monthFormat} ${day}, ${year} ${hour}:${min}`,
            withAll: `${monthFormat} ${day}, ${year}(${week}) ${hour}:${min}`,
            thatDay,
        }
    }
    return {
        withYear: `${day}/${month}/${year} ${hour}:${min}`,
        withMonth: `${month}-${day} ${hour}:${min}`,
        withDay: `${week} ${hour}:${min}`,
        withLastDay: `${yesterday} ${hour}:${min}`,
        withHour: `${today} ${hour}:${min}`,
        withNoWeekAll: `${monthFormat} ${day}, ${year} ${hour}:${min}`,
        withAll: `${monthFormat} ${day}, ${year}(${week}) ${hour}:${min}`,
        thatDay,
    }
}

/* 格式化日期 */
Utils.formatDate = function (datetime, lang, simple = false) {
    let tempDate = (new Date()).getTime()
    let result = this.stringifyDate(datetime, lang, simple)
    let thatDay = result.thatDay
    let deltaTime = (tempDate - thatDay) / 1000

    if (deltaTime < 3600 * 24) {
        return result.withHour
    }
    if (deltaTime < 3600 * 24 * 2) {
        return result.withLastDay
    }
    return result.withAll

    // else if (deltaTime < 3600 * 24 * 7) {
    //     return result.withDay
    // } else if (deltaTime < 3600 * 24 * 30) {
    //     return result.withMonth
    // } else {
    //     return result.withYear
    // }
}

Utils.parseSession = function (sessionId) {
    if (/^p2p-/.test(sessionId)) {
        return {
            scene: 'p2p',
            to: sessionId.replace(/^p2p-/, ''),
        }
    }
    if (/^team-/.test(sessionId)) {
        return {
            scene: 'team',
            to: sessionId.replace(/^team-/, ''),
        }
    }
    return {
        scene: 'p2p',
        to: sessionId,
    }
}
Utils.returnSessionId = function (customerId) {
    return (/^\d+$/.test(customerId) ? 'team-' : 'p2p-') + customerId       // 纯数字说明是team
}

Utils.getSessionType = function (customerId) {
    if (/^\d+$/.test(customerId)) {
        return 'team'
    }
    return 'p2p'
}

Utils.parseCustomMsg = function (msg) {
    if (msg.type === 'custom') {
        try {
            let cnt = JSON.parse(msg.content)
            switch (cnt.type) {
                case 1:
                    return '[猜拳消息]'
                case 2:
                    return '[阅后即焚]'
                case 3:
                    return '[贴图表情]'
                case 4:
                    return '[白板消息]'
                default:
                    break
            }
        } catch (e) {
            return ''
        }
        return '[自定义消息]'
    }
    return ''
}
/* 获得有效的备注名 */
Utils.getFriendAlias = function (userInfo) {
    userInfo.alias = userInfo.alias ? userInfo.alias.trim() : ''
    return userInfo.alias || userInfo.nick || userInfo.account
}

Utils.getNickNames = function (users) {
    return users.map(user => (user.account === store.state.chat.userUID ? '你' : user.nick))
}

Utils.getTeamUpdateInfo = function (msg) {
    let text
    let team = msg.attach.team
    let op = this.getNickNames(msg.attach.users).pop()
    if (team.name) {
        text = `${op}修改群名为${team.name}`
    } else if (team.intro) {
        text = `${op}修改群介绍为${team.intro}`
    } else if (team.joinMode) {
        text = `群身份验证模式更新为${team.joinMode === 'noVerify' ? '不需要验证' : team.joinMode === 'needVerify' ? '需要验证' : '禁止任何人加入'}`
    } else if (team.inviteMode) {
        text = `邀请他人权限为${team.inviteMode === 'all' ? '所有人' : '管理员'}`
    } else if (team.updateTeamMode) {
        text = `群资料修改权限为${team.updateTeamMode === 'all' ? '所有人' : '管理员'}`
    } else if (team.beInviteMode) {
        text = `被邀请人身份${team.beInviteMode === 'noVerify' ? '不需要验证' : '需要验证'}`
    } else {
        text = '更新群信息'
    }
    return text
}

Utils.teamConfigMap = {
    joinMode: {
        noVerify: '不需要验证',
        needVerify: '需要验证',
        rejectAll: '禁止任何人加入',
    },
    beInviteMode: {
        needVerify: '需要验证',
        noVerify: '不需要验证',
    },
    inviteMode: {
        manager: '管理员邀请',
        all: '所有人邀请',
    },
    updateTeamMode: {
        manager: '管理员修改',
        all: '所有人修改',
    },
    memberType: {
        manager: '管理员',
        normal: '普通成员',
    },
}
Utils.getFileSize = function (value) {
    if (value == null || value === '') {
        return '0 Bytes'
    }
    let unitArr = ['Bytes', 'KB', 'M', 'G', 'TB', 'PB', 'EB', 'ZB', 'YB']
    let index = 0
    let srcsize = parseFloat(value)
    index = Math.floor(Math.log(srcsize) / Math.log(1024))
    let size = srcsize / (1024 ** index)
    size = size.toFixed(2)// 保留的小数位数
    return size + ' ' + unitArr[index]
}
Utils.getImageUrl = function (value, name, standbyImg) {
    if (value[name]) {
        if (value[name].charAt(0) !== '/') {
            value.imageURL = 'http://images.eggmalltech.com/' + value[name]
            value.imageResizeURL = 'http://images.eggmalltech.com/' + value[name] + '?x-oss-process=image/resize,w_120'
        } else if (value[name].charAt(0) === '/') {
            value.imageURL = 'http://images.eggmalltech.com' + value[name]
            value.imageResizeURL = 'http://images.eggmalltech.com' + value[name] + '?x-oss-process=image/resize,w_120'
        }
    } else if (standbyImg) {
        value.imageURL = standbyImg
        value.imageResizeURL = standbyImg + '?x-oss-process=image/resize,w_120'
    }
    return value
}

export default Utils
